import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    /**************************************************************
    -> Pageload animation
    **************************************************************/
    function pageDestinationsLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-destinations .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-destinations .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-destinations .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
      .to('.hero-destinations .wrap-hero-header a', { opacity: 1 }, '>-0.35')
    }
    pageDestinationsLoadAnimation()

    /**************************************************************
    -> Destinations intro anim on scroll
    **************************************************************/
    function inViewAnimIntroDestinations() {
      gsap.fromTo('.intro-destinations .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-destinations .intro-container',
      })

      gsap.fromTo('.intro-destinations .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-destinations .intro-container',
      })

    }
    inViewAnimIntroDestinations();

    /**************************************************************
    -> Destinations List anim on scroll
    **************************************************************/
    function inViewAnimListDestinations() {
      gsap.fromTo('.list-destinations .wrap-destinations-list .destination-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        stagger: {
          each: 0.05,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.list-destinations .wrap-destinations-list',
      })

    }
    inViewAnimListDestinations();

    /**************************************************************
    -> Home quotes anim on scroll
    **************************************************************/
    function inViewAnimQuote() {
      gsap.fromTo('.clients-say-destinations h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.clients-say-destinations',
      })

      gsap.fromTo('.clients-say-destinations .wrap-carousel' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-destinations h2',
      })
    }
    inViewAnimQuote();

    // eslint-disable-next-line no-unused-vars
    let destinationsQuoteSwiper = new Swiper ('.swiper-container-destinations-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/destinations.js